import { render, staticRenderFns } from "./IconSortAlphabetical.vue?vue&type=template&id=2e04b6e9&"
import script from "./IconSortAlphabetical.vue?vue&type=script&lang=js&"
export * from "./IconSortAlphabetical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports